import { jsx as o, Fragment as b, jsxs as g } from "react/jsx-runtime";
import { useState as L, useMemo as v, useCallback as k, useLayoutEffect as y } from "react";
import t from "./styles.module.less.js";
import A from "./logo.webp.js";
import { usePathname as N } from "../../../utils/use-pathname.js";
import { AccountLink as I } from "./account-link/index.js";
import { FLOATING_CONTAINER_ID as m } from "./index.js";
import { areasOfLawData as C } from "../../../constants.js";
import { convertToKebabCase as D } from "../../../utils/case-conversion.js";
import { DropdownMenuItemDesktop as w } from "./dropdown-menu-item/index.js";
import { getAboutLinks as E } from "./get-about-links.js";
import { ForLawyersMenuButtonDesktop as M } from "./for-lawyers-button/index.js";
import { GetHelpMenuItemDesktop as S } from "./get-help-menu-item/index.js";
import { MenuChatButtonDesktop as R } from "./chat-button/index.js";
const T = "/help", J = (a) => {
  const { getTranslation: s, language: e, isLawyerSupported: d = !1 } = a, n = N(), [i, f] = L(!1), c = v(() => {
    const r = C[e];
    if (r)
      return [
        ...r.map((u) => ({
          ...u,
          path: `/${e}/${D(u.title)}`
        }))
      ];
  }, [e]), l = k(
    (r) => {
      switch (r) {
        case "/chat":
          return n === "/chat";
        case "/about":
          return n === `/${e}/about`;
        case "/help":
          return n === T;
        case "/library":
          return n === `/${e}/library`;
        case "/account":
          return n === "/account";
        default:
          return !1;
      }
    },
    [n, c, e]
  );
  return y(() => {
    const r = () => {
      var h, p;
      (window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0) > 80 ? ((h = document.getElementById(m)) == null || h.classList.add(t.shrink), f(!0)) : ((p = document.getElementById(m)) == null || p.classList.remove(t.shrink), f(!1));
    };
    return window.addEventListener("scroll", r), document.body.addEventListener("scroll", r), r(), () => {
      window.removeEventListener("scroll", r), document.body.removeEventListener("scroll", r);
    };
  }, []), /* @__PURE__ */ o(b, { children: /* @__PURE__ */ o("div", { className: t.floatingContainer, id: m, children: /* @__PURE__ */ g("div", { className: t.menuContentContainer, children: [
    /* @__PURE__ */ o(
      "a",
      {
        href: e ? `/${e}` : "/",
        className: t.logoContainer,
        children: /* @__PURE__ */ o(
          "img",
          {
            src: A,
            alt: "logo",
            width: 0,
            height: 20,
            className: t.logo
          }
        )
      }
    ),
    /* @__PURE__ */ g("div", { className: t.menuLinksContainer, children: [
      d ? /* @__PURE__ */ o(
        S,
        {
          language: e,
          titleLabel: s("pages.get-help"),
          getTranslation: s,
          hasShrunk: i,
          isLawyerSupported: !0,
          onRequestLawyer: a.onRequestLawyer,
          isActive: l(
            "/help"
            /* HELP */
          )
        }
      ) : /* @__PURE__ */ o(
        R,
        {
          getTranslation: s,
          isScrolledHeader: i
        }
      ),
      d ? null : /* @__PURE__ */ o("div", { className: t.spacer }),
      c ? /* @__PURE__ */ o(
        w,
        {
          language: e,
          items: c,
          titleLabel: s("pages.areas-of-law"),
          hasShrunk: i,
          link: `/${e}/library`,
          classNames: {
            container: t.subMenuContainer,
            itemRow: t.offsetDropdownItemRow
          },
          isActive: l(
            "/library"
            /* KNOWLEDGE_BASE */
          )
        }
      ) : null,
      /* @__PURE__ */ o(
        w,
        {
          language: e,
          titleLabel: s("pages.about"),
          link: `/${e}/about`,
          hasShrunk: i,
          items: E({ language: e, getTranslation: s }),
          classNames: {
            container: t.subMenuContainer,
            itemRow: t.offsetDropdownItemRow
          },
          isActive: l(
            "/about"
            /* ABOUT */
          )
        }
      ),
      /* @__PURE__ */ o(
        M,
        {
          language: e,
          getTranslation: s,
          isScrolledHeader: i,
          isActive: l(
            "/register-interest"
            /* FOR_LAWYERS */
          )
        }
      ),
      /* @__PURE__ */ o(
        I,
        {
          isScrolledHeader: i,
          isActive: l(
            "/account"
            /* ACCOUNT */
          ),
          isAuthenticated: a.isAuthenticated,
          userImage: a.userImage,
          openAuthModal: a.openAuthModal,
          logout: a.logout,
          hasNotifications: a.hasNotifications,
          language: e,
          getTranslation: s
        }
      )
    ] })
  ] }) }) });
};
export {
  J as DesktopMenu
};
